import React, { useReducer } from 'react';
import CartReducer from "./CartReducer";
import OrderData from "../OrderData";
// import AddToCartNo from './AddToCartNo';
// export const CartContext = createContext();
import Context from './Context';
const data = {
    items: OrderData,
};

const CartContextProvider = (props) => {

    const [cart, dispatch] = useReducer(CartReducer, data);
    // const [cart1, dispatch1] = useReducer(AddToCartNo, data1);

    const removeItems = (_id) => {
        return dispatch({
            type: "REMOVE_ITEMS",
            payload: _id,
        });
    };


    return (
        <Context.Provider value={{ ...cart, removeItems, }}>
            {props.children}
        </Context.Provider>
    );
};

export default CartContextProvider;
